<template>
  <component :is="headerTag" class="card-header" :class="headerClass">
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: 'PostCardHeader',
  props: {
    headerTag: {
      type: String,
      default: 'div'
    },
    variant: {
      type: String,
      default: ''
    }
  },
  computed: {
    headerClass() {
      const classes = [];
      if (this.variant) {
        classes.push(`bg-${this.variant}`);
      }
      return classes.join(' ');
    }
  }
};
</script>

<style scoped></style>